module.exports = kolibriGlobal.coreVue.components.KTextbox;